setTimeout(function () {

  // ── COLOR SWATCH CONFIG ──────────────────────────────────────────────────
  const HEX_MAP = {
    'White':        '#FFFFFF',
    'Black':        '#1C1C1C',
    'Silver':       '#A3A3A3',
    'Red':          '#D2143A',
    'Navy':         '#0B1D33',
    'Royal Blue':   '#0D47A1',
    'Sky Blue':     '#7BAFD4',
    'Kelly Green':  '#008751',
    'Forest Green': '#1B4D3E',
    'Orange':       '#FF6600',
    'Maroon':       '#5C061D',
    'Purple':       '#4A154B',
    'Gold':         '#FFC72C',
    'Neon Yellow':  '#CEFF00',
    'Neon Green':   '#39FF14',
    'Neon Orange':  '#FF5F1F',
    'Neon Pink':    '#FF1493',
    'Neon Blue':    '#00E5FF'
  };

  const COLOR_FIELDS = [
    'String Colors',
    'Shooter Colors',
    'Mesh Color'
  ];

  // ── HEAD IMAGE + COLOR CONFIG ────────────────────────────────────────────
  const BASE = 'https://cdn.shopify.com/s/files/1/0791/3603/0869/files/';

  const HEAD_DATA = {
    'ECD Atom': {
      colors: {
        'White': BASE + 'ECD_Atom_Whiye.jpg?v=1783192154',
        'Ghost': BASE + 'ECD_Atom_Ghost.webp?v=1783276790',
        'Frost': BASE + 'ATOM-Frost-Unstrung-Face_1080x_bab41fbe-05cb-4e66-bac7-c7ace306965c.webp?v=1783193149'
      }
    },
    'ECD Ion': {
      colors: {
        'Clear':    BASE + 'ECD_ION_Clear.png?v=1783276790',
        'Orange':   BASE + 'ECD_ION_Orange.jpg?v=1783193149',
        'Midnight': BASE + 'ECD_ION_MIdnight.jpg?v=1783193149',
        'Galaxy':   BASE + 'Ion-Galaxy-Unstrung-Face_360x_c851a5a8-1605-43fb-b4af-172d607a839e.webp?v=1783193149',
        'Frost':    BASE + 'ECD_ION_Frost.webp?v=1783276789',
        'Lime':     BASE + 'ECD_ION_LIME.webp?v=1783276938',
        'Ruby':     BASE + 'ECD_ION_Ruby.webp?v=1783276790'
      }
    },
    'ECD Mirage 3.0': {
      colors: { 'White': BASE + 'ECD_Mirage_3.0.webp?v=1783193149' }
    },
    'ECD DNA 2.0': {
      colors: { 'White': BASE + 'ECD_DNA_2.0_WHite.png?v=1783276195' }
    },
    'ECD Delta': {
      colors: {
        'White': BASE + 'ECD_Delta_White.png?v=1783276195',
        'Black': BASE + 'ECD_Delta_Black.webp?v=1783193149'
      }
    },
    'ECD Rebel Offense': {
      colors: { 'White': BASE + 'ECD_Rebel_O_White.webp?v=1783276194' }
    },
    'ECD Weapon X 2.0': {
      colors: { 'White': BASE + 'weapon_x_2.0_White.webp?v=1783193149' }
    },
    'ECD Diamond Impact': {
      colors: { 'Clear': BASE + 'ECD_Diamond_Impact_Clear.webp?v=1783276193' }
    },
    'STX Prism': {
      colors: { 'Clear': BASE + 'STX_PRISM_CLEAR.png?v=1783276195' }
    },
    'STX Hammer 1K': {
      colors: {
        'White': BASE + 'stx_hammer.webp?v=1783193149',
        'Black': BASE + 'stx_hammer_black.webp?v=1783193149'
      }
    },
    'STX Stallion 1K': {
      colors: {
        'White': BASE + 'STX_STALLION_1K_WHITE.png?v=1783276195',
        'Black': BASE + 'STX_Stallion_1k_black_30bbb35f-7a4b-4d2b-a921-d608de017aba.webp?v=1783276194'
      }
    },
    'STX Surgeon 1K': {
      colors: {
        'White': BASE + 'STX_Surgeon_1K_White.webp?v=1783276789',
        'Black': BASE + 'STX_Surgeon_1K_Black.webp?v=1783193149'
      }
    },
    'STX Magnet 2K': {
      colors: {
        'White': BASE + 'STX_Magnet_2K_White.png?v=1783276790',
        'Black': BASE + 'STX_Magnet_Black_750e7bc5-e9cd-45f3-a242-e6104df5ddc6.webp?v=1783006633'
      }
    },
    'STX Hyper Power': {
      colors: { 'White': BASE + 'STX_Hyper_Power.webp?v=1783276938' }
    },
    'STX Eclipse 3': {
      colors: { 'White': BASE + 'STX_Eclipse_3_White.png?v=1783276195' }
    },
    'Warrior EVO QX2-O': {
      colors: {
        'White': BASE + 'Warrior_QX2_O_White.webp?v=1783276789',
        'Black': BASE + 'qx2_o_black.webp?v=1783193149'
      }
    },
    'Warrior EVO QX2-D': {
      colors: {
        'White':   BASE + 'qx2_D.webp?v=1783193149',
        'Black':   BASE + 'qx2_D_Black_d7871fc7-0bc9-4542-8fb6-30c73c6893d6.webp?v=1783193149',
        'Natural': BASE + 'Warrior_QX2_D_Natural.webp?v=1783276789'
      }
    },
    'StringKing Mark 3A': {
      colors: { 'White': BASE + 'Stringking_Mark_3A.webp?v=1783276789' }
    },
    'StringKing Mark 3D': {
      colors: { 'White': BASE + 'Stringking_Mark_3D.webp?v=1783276789' }
    },
    'StringKing Mark 2F': {
      colors: { 'White': BASE + 'Stringking_mark_2f_white.png?v=1783276195' }
    },
    'StringKing Mark 2F Stiff': {
      colors: { 'White': BASE + 'Stringking_mark_2f_stiff_white.png?v=1783276195' }
    },
    'Maverik Tank 2': {
      colors: {
        'White': BASE + 'Maverik_Tank_2_White.png?v=1783276195',
        'Black': BASE + 'Maverik_Tank_2_Black.webp?v=1783276194'
      }
    },
    'Maverik Kimera': {
      colors: { 'White': BASE + 'Maverik_Kimera_Whitye.png?v=1783276195' }
    },
    'Maverik Havok 2': {
      colors: {
        'White': BASE + 'Maverik_Havok_2_whiye.png?v=1783276195',
        'Black': BASE + 'Maverik_Havok_2_black.webp?v=1783276194'
      }
    },
    'Maverik Tactik 3': {
      colors: { 'White': BASE + 'Maverik_Tactik_3_white.png?v=1783276195' }
    },
    'Maverik Optic Force': {
      colors: { 'White': BASE + 'Maverik_Optik_Force_White.png?v=1783276195' }
    }
  };

  // ── STYLES ───────────────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    .prz-head-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
      gap: 10px;
      margin-bottom: 16px;
    }
    .prz-head-card {
      background: #1c1c1c;
      border: 2px solid rgba(255,255,255,0.1);
      border-radius: 8px;
      padding: 8px;
      cursor: pointer;
      text-align: center;
      transition: border-color 0.2s, transform 0.15s;
    }
    .prz-head-card:hover {
      border-color: #4ec9c9;
      transform: translateY(-2px);
    }
    .prz-head-card.selected {
      border-color: #4ec9c9;
      background: rgba(78,201,201,0.08);
    }
    .prz-head-card img {
      width: 100%;
      aspect-ratio: 1;
      object-fit: contain;
      border-radius: 4px;
      margin-bottom: 6px;
      background: #fff;
    }
    .prz-head-card .prz-head-name {
      font-size: 10px;
      color: rgba(255,255,255,0.7);
      line-height: 1.3;
      word-break: break-word;
    }
    .prz-head-card.selected .prz-head-name {
      color: #4ec9c9;
    }
    .prz-color-row {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 12px;
      margin-bottom: 16px;
    }
    .prz-color-chip {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      cursor: pointer;
    }
    .prz-color-chip img {
      width: 52px;
      height: 52px;
      object-fit: contain;
      border-radius: 6px;
      border: 2px solid rgba(0, 0, 0, 1);
      background: #fff;
      transition: border-color 0.2s, transform 0.15s;
    }
    .prz-color-chip:hover img { border-color: #4ec9c9; transform: scale(1.08); }
    .prz-color-chip.selected img { border-color: #4ec9c9; box-shadow: 0 0 0 2px rgba(78,201,201,0.3); }
    .prz-color-chip span {
      font-size: 10px;
      color: rgba(255,255,255,0.55);
      text-align: center;
    }
    .prz-color-chip.selected span { color: #4ec9c9; }
    .prz-section-label {
      font-size: 13px;
      font-weight: 500;
      color: #fff;
      margin: 0 0 10px;
      width: 100%;
    }
    .prz-missing-img {
      width: 52px;
      height: 52px;
      border-radius: 6px;
      border: 2px dashed rgba(255,255,255,0.2);
      background: #1c1c1c;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 9px;
      color: rgba(255,255,255,0.3);
      text-align: center;
    }
  `;
  document.head.appendChild(style);

  // ── HEAD SELECTOR ────────────────────────────────────────────────────────
  function buildHeadSelector() {
    const headSelect = document.querySelector('select[data-field-name="Head Model"]');
    const colorSelect = document.querySelector('select[data-field-name="Head Color"]');
    if (!headSelect || !colorSelect) return;

    headSelect.style.display = 'none';
    colorSelect.style.display = 'none';

    // Wrapper
    const wrapper = document.createElement('div');

    // Head grid label
    const headLabel = document.createElement('p');
    headLabel.className = 'prz-section-label';
    headLabel.textContent = 'Head Model';
    wrapper.appendChild(headLabel);

    // Head grid
    const grid = document.createElement('div');
    grid.className = 'prz-head-grid';

    // Color row (hidden until head selected)
    const colorRow = document.createElement('div');
    colorRow.className = 'prz-color-row';
    colorRow.style.display = 'none';

    const colorLabel = document.createElement('p');
    colorLabel.className = 'prz-section-label';
    colorLabel.textContent = 'Head Color';
    colorLabel.style.display = 'none';

    // Build head cards
    Array.from(headSelect.options).forEach(function (opt) {
      if (!opt.value) return;
      const data = HEAD_DATA[opt.value];
      if (!data) return;

      const firstImg = Object.values(data.colors).find(function (u) { return u; });

      const card = document.createElement('div');
      card.className = 'prz-head-card';
      card.dataset.head = opt.value;

      const img = document.createElement('img');
      img.src = firstImg || '';
      img.alt = opt.value;
      img.loading = 'lazy';
      if (!firstImg) img.style.display = 'none';

      const name = document.createElement('p');
      name.className = 'prz-head-name';
      name.textContent = opt.value;

      card.appendChild(img);
      card.appendChild(name);

      card.addEventListener('click', function () {
        grid.querySelectorAll('.prz-head-card').forEach(function (c) {
          c.classList.remove('selected');
        });
        card.classList.add('selected');
        headSelect.value = opt.value;
        headSelect.dispatchEvent(new Event('change', { bubbles: true }));

        // Build color chips
        colorRow.innerHTML = '';
        colorLabel.style.display = 'block';
        colorRow.style.display = 'flex';

        const colors = data.colors;
        const colorKeys = Object.keys(colors);

        if (colorKeys.length === 1) {
          // Auto-select single color silently
          colorSelect.value = colorKeys[0];
          colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          colorRow.style.display = 'none';
          colorLabel.style.display = 'none';
          return;
        }

        colorKeys.forEach(function (colorName) {
          const imgUrl = colors[colorName];
          const chip = document.createElement('div');
          chip.className = 'prz-color-chip';

          if (imgUrl) {
            const cImg = document.createElement('img');
            cImg.src = imgUrl;
            cImg.alt = colorName;
            cImg.loading = 'lazy';
            chip.appendChild(cImg);
          } else {
            const placeholder = document.createElement('div');
            placeholder.className = 'prz-missing-img';
            placeholder.textContent = 'Coming soon';
            chip.appendChild(placeholder);
          }

          const label = document.createElement('span');
          label.textContent = colorName;
          chip.appendChild(label);

          chip.addEventListener('click', function () {
            colorRow.querySelectorAll('.prz-color-chip').forEach(function (c) {
              c.classList.remove('selected');
            });
            chip.classList.add('selected');
            colorSelect.value = colorName;
            colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });

          colorRow.appendChild(chip);
        });
      });

      grid.appendChild(card);
    });

    wrapper.appendChild(grid);
    wrapper.appendChild(colorLabel);
    wrapper.appendChild(colorRow);
    headSelect.parentNode.insertBefore(wrapper, headSelect);
  }

  // ── COLOR SWATCHES ───────────────────────────────────────────────────────
  function buildColorSwatches() {
    COLOR_FIELDS.forEach(function (fieldName) {
      const select = document.querySelector(
        'select[data-field-name="' + fieldName + '"]'
      );
      if (!select) return;

      select.style.display = 'none';

      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px;';

      const swatchLabel = document.createElement('p');
      swatchLabel.className = 'prz-section-label';
      swatchLabel.textContent = fieldName.replace('&amp;', '&');
      wrapper.appendChild(swatchLabel);

      Array.from(select.options).forEach(function (opt) {
        if (!opt.value) return;
        const hex = opt.value.startsWith('#') ? opt.value : HEX_MAP[opt.value];
        if (!hex) return;

        const swatch = document.createElement('div');
        swatch.setAttribute('data-swatch', opt.value);
        swatch.title = opt.text.trim();
        swatch.style.cssText = [
          'width:36px',
          'height:36px',
          'border-radius:50%',
          'background:' + hex,
          'border:2px solid rgba(0, 0, 0, 1)',
          'cursor:pointer',
          'transition:transform 0.15s',
          'position:relative'
        ].join(';');

        swatch.addEventListener('mouseenter', function () {
          this.style.transform = 'scale(1.15)';
        });
        swatch.addEventListener('mouseleave', function () {
          this.style.transform = 'scale(1)';
        });

        swatch.addEventListener('click', function () {
          wrapper.querySelectorAll('[data-swatch]').forEach(function (s) {
            s.style.border = '2px solid rgba(0, 0, 0, 1)';
            s.style.boxShadow = 'none';
          });
          this.style.border = '2px solid #4ec9c9';
          this.style.boxShadow = '0 0 0 3px rgba(78,201,201,0.3)';
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        wrapper.appendChild(swatch);
      });

      select.parentNode.insertBefore(wrapper, select);
    });
  }

  // ── CART COLOR DOTS ──────────────────────────────────────────────────────
  function injectCartSwatches() {
    document.querySelectorAll('.cart-items__bundle li').forEach(function (li) {
      const text = li.textContent.trim();
      const hex = HEX_MAP[text];
      if (!hex || li.querySelector('.cart-color-dot')) return;
      const dot = document.createElement('span');
      dot.className = 'cart-color-dot';
      dot.style.cssText = [
        'display:inline-block',
        'width:12px',
        'height:12px',
        'border-radius:50%',
        'background:' + hex,
        'border:1px solid rgba(0,0,0,0.2)',
        'margin-right:6px',
        'vertical-align:middle',
        'flex-shrink:0'
      ].join(';');
      li.insertBefore(dot, li.firstChild);
    });
  }

  // ── INIT ─────────────────────────────────────────────────────────────────
  buildHeadSelector();
  buildColorSwatches();
  injectCartSwatches();

  const observer = new MutationObserver(injectCartSwatches);
  observer.observe(document.body, { childList: true, subtree: true });

}, 2000);

// ─────────────────────────────────────────────────────────────────────────────
// PRZ CHECKOUT / DROP-OFF HANDLING
// Shopify + MCF are the ONLY source of truth for pricing.
// No custom calculator.
// No reservation products.
// No duplicate totals.
// ─────────────────────────────────────────────────────────────────────────────

(function setupPRZForm() {

  function getDropOffSelect() {
    return document.querySelector(
      'select[data-field-name="Drop Off Location"]'
    );
  }

  function getProductForm() {
    return document.querySelector('form[action^="/cart/add"]');
  }

  // Keep the normal Shopify/MCF form submission completely intact.
  // MCF needs to submit its options together with the actual PRZ product.
  function initializeForm() {
    var form = getProductForm();

    if (!form) {
      console.warn('PRZ: Shopify product form not found.');
      return false;
    }

    console.log('PRZ: Shopify/MCF product form ready.');

    var dropOff = getDropOffSelect();

    if (dropOff) {
      console.log(
        'PRZ: Drop Off Location detected:',
        dropOff.value
      );
    }

    return true;
  }

  // MCF can initialize after the theme loads, so give it a little time.
  var attempts = 0;
  var maxAttempts = 20;

  var waitForForm = setInterval(function () {

    attempts++;

    if (initializeForm()) {
      clearInterval(waitForForm);
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(waitForForm);
      console.warn('PRZ: Could not find Shopify product form.');
    }

  }, 500);

})();